import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { getMessages, deleteDeferred } from '../../../redux/actions/conversations/messagesAct'
import { I18n } from 'react-redux-i18n'

import messageFiltersAct from '../../../redux/actions/conversations/messageFiltersAct'
import settingsActions from 'redux/settings/actions'
import Message, { DraftMessage, DeferredMessage } from './ChatChannelMessage'
import ScrollableContent from 'components/ScrollableContent'
import ComposerPreviewReply from './ComposerPreviewReply'
import { composerAct } from 'redux/actions'

import moment from 'moment'

class ChatMessages extends React.Component {
  constructor(props) {
    super(props)

    // @TODO Comentadas el día 22 por la incidencia https://ksventurespm.atlassian.net/browse/NPRODUCT-757
    // this.state = {
    //   scrollUpAvailable: false
    // }

    this.isFetchingMessages = true

    this.messagesAct = bindActionCreators({ getMessages, deleteDeferred }, props.dispatch)
    this.messageFiltersAct = bindActionCreators(messageFiltersAct, props.dispatch)
    this.settingsActions = bindActionCreators(settingsActions, props.dispatch)
    this.composerAct = bindActionCreators(composerAct, props.dispatch)

    this.loadMessages = this.loadMessages.bind(this)
    this.toggleFetchingMessages = this.toggleFetchingMessages.bind(this)
    // @TODO Comentadas el día 22 por la incidencia https://ksventurespm.atlassian.net/browse/NPRODUCT-757
    // this.onYReachStart = this.onYReachStart.bind(this)
  }

  componentDidMount() {
    const { user, chat, settings: { msgFilterEvent } } = this.props

    let data = { user, messages: chat.messages, eventType: msgFilterEvent }
    this.messagesAct.getMessages(data)
      .then(this.toggleFetchingMessages)
  }

  componentDidUpdate(prevProps) {
    const {
      composer: { currentSubject },
      user,
      chat: { messages, messageFilters, loadingMessages },
      settings: { msgFilterEvent }
    } = this.props

    const {
      composer: { currentSubject: oldCurrentSubject },
      chat: { messageFilters: oldMessageFilters },
      settings: { msgFilterEvent: oldMsgFilterEvent }
    } = prevProps

    // user id has changed
    if (prevProps.user.id !== user.id && !messages.length) {
      // if we don't have messages, set state as loading and load them
      // usualy happens because new user is selected
      let data = { user, messages, eventType: msgFilterEvent }
      this.messagesAct.getMessages(data)
    }

    // Maybe filters changed
    if (
      (oldMessageFilters && !loadingMessages.fetching) ||
      msgFilterEvent !== oldMsgFilterEvent
    ) {
      // This is for getting messages everytime filter changes
      if (
        messageFilters.filterValue.length !== oldMessageFilters.filterValue.length ||
        messageFilters.filterText !== oldMessageFilters.filterText ||
        currentSubject !== oldCurrentSubject ||
        msgFilterEvent !== oldMsgFilterEvent
      ) {
        this.messageFiltersAct.getFilteredMessages({
          user,
          filterTypes: messageFilters.filterValue.join(','),
          text: messageFilters.filterText,
          subjectId: currentSubject?._id || '',
          eventType: msgFilterEvent
        })
      }
    }
  }

  toggleFetchingMessages() {
    this.isFetchingMessages = !this.isFetchingMessages
  }

  loadMessages(params = {}) {
    const { up } = params
    const {
      user,
      chat: { messages },
      settings: { msgFilterEvent }
    } = this.props

    if (this.isFetchingMessages) return
    if (!messages.length) return
    // If we have all the new messages loaded
    if (up && messages.length > 0 && messages[0].lastMessage) return
    // If we have all the old messages loaded
    if (messages.length > 0 && messages[messages.length - 1].firstMessage) return

    // Perform query to get older messages
    this.toggleFetchingMessages()

    let data = { user, messages, isPoll: false, eventType: msgFilterEvent, up }
    this.messagesAct.getMessages(data)
      .finally(this.toggleFetchingMessages)
  }

  // @TODO Comentadas el día 22 por la incidencia https://ksventurespm.atlassian.net/browse/NPRODUCT-757
  // onYReachStart() {
  //   const {
  //     settings: { messageIdToGo },
  //     chat: { loadingMessages }
  //   } = this.props
  //   if (loadingMessages?.fetching) return
  //   if (loadingMessages?.fetchingUp) return
  //   if (!messageIdToGo) return

  //   this.loadMessages({ up: true })
  // }

  render() {
    const {
      settings: {
        msgFilterEvent,
        // @TODO Comentadas el día 22 por la incidencia https://ksventurespm.atlassian.net/browse/NPRODUCT-757
        // messageIdToGo
      },
      chat: { messages, drafts, loadingMessages, deferredMessages },
      user,
      operator,
      activitiesTypes,
      isOpenMessageOptionsSelector,
      toggleMessageOptionsSelector,
      toggleDeleteDraftModal,
      handleEditDraft,
      handleToggleShowHideDraft,
      handleMessageOption,
      toggleSidePopup,
      composer
    } = this.props

    const newMessages = []
    messages.forEach(message => newMessages.push({
      ...message,
      messageType: 'normal'
    }))

    const newDrafts = []
    drafts.forEach(draft => newDrafts.push({
      ...draft,
      date: draft.updatedAt,
      messageType: 'draft'
    }))

    const combinedMessages = [...newMessages, ...newDrafts]
    const parsedMessages = combinedMessages.sort((dateA, dateB) => moment(dateB.date) - moment(dateA.date))

    const allMessages =  [...parsedMessages, ...deferredMessages.messages]

    return (
      <div className='messages-container'>
        {
          composer?.inReplyTo ? (
            <ComposerPreviewReply
              inReplyTo={composer?.inReplyTo}
              replyInfo={composer?.replyInfo}
              onRemove={() => this.composerAct.removeReply()}
            />
          ) : null
        }
        <ScrollableContent
          goToTop
          // @TODO Comentadas el día 22 por la incidencia https://ksventurespm.atlassian.net/browse/NPRODUCT-757
          // goToId={messageIdToGo}
          // onScrollDown={() => {
          //   console.log('hola', this.state.scrollUpAvailable)
          //   if (!this.state.scrollUpAvailable) this.setState({ scrollUpAvailable: true })
          // }}
          onYReachEnd={() => {
            // @TODO Comentadas el día 22 por la incidencia https://ksventurespm.atlassian.net/browse/NPRODUCT-757
            // if (allMessages.length && messageIdToGo) this.settingsActions.set({ dateToSearchMessages: '', messageIdToGo: '' })
            this.loadMessages()
          }}
          // @TODO Comentadas el día 22 por la incidencia https://ksventurespm.atlassian.net/browse/NPRODUCT-757
          // onYReachStart={this.onYReachStart}
        >
          <div className='messages'>
            {loadingMessages.fetchingUp ? (
              <p className='messages__info'>{`${I18n.t('dashboard_loading-messages')}...`}</p>
            ) : null}

            {deferredMessages.shouldShow ?
              deferredMessages.messages.map((msg, index) => (
                <DeferredMessage
                  key={`${index}-${user.id}-${msg.status}-${msg.scheduledAt}`}
                  user={{ name: user.name }}
                  content={msg}
                  deleteDeferred={(deferredId) => this.messagesAct.deleteDeferred(deferredId)}
                />
              )) : null
            }
            {
              parsedMessages.map((message, index) => {
                if (message.messageType === 'normal') {
                  return (
                    <Message
                      key={`${index}-${user.id}-${message.type}-${message.date}`}
                      user={user}
                      operator={operator}
                      content={message}
                      activitiesTypes={activitiesTypes}
                      isOpenMessageOptionsSelector={isOpenMessageOptionsSelector}
                      toggleMessageOptionsSelector={toggleMessageOptionsSelector}
                      handleMessageOption={handleMessageOption}
                      toggleSidePopup={toggleSidePopup}
                    />
                  )
                }

                if (message.messageType === 'draft' && message.type === 'chat') {
                  return (
                    <DraftMessage
                      key={`${index}-${user.id}-${message.type}-${message.date}`}
                      user={user}
                      content={message}
                      toggleDeleteDraftModal={toggleDeleteDraftModal}
                      handleEditDraft={handleEditDraft}
                      handleToggleShowHideDraft={handleToggleShowHideDraft}
                    />
                  )
                }

                return null
              })}

            {loadingMessages.fetching ? (
              <p className='messages__info'>{`${I18n.t('dashboard_loading-messages')}...`}</p>
            ) : null}

            {(!loadingMessages.fetching && allMessages.length <= 0) ? (
              ['messages', 'activities'].includes(msgFilterEvent) ? (
                <p className='messages__info'>{I18n.t('dashboard_conversations_noResultsFilter')}</p>
              ) : (
                <p className='messages__info'>{I18n.t('dashboard_no-messages')}</p>
              )
            ) : null}

            {(!loadingMessages.fetching && allMessages[allMessages.length - 1]?.firstMessage) ? (
              <p className='messages__info'>{I18n.t('dashboard_no-more-messages')}</p>
            ) : null}
          </div>
        </ScrollableContent>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  settings: state.settings,
  operator: state.user
})

export default connect(mapStateToProps)(ChatMessages)
